<template>
  <div
    v-if="errorMessage || successMessage"
    class="ftn-message"
  >
    <transition name="fade">
      <div
        v-if="errorMessage"
        class="ftn-message__alert ftn-message__alert_error"
        role="alert"
        @click="copyErrorMessage"
      >
        <ErrorMarkIcon class="ftn-message__icon" />
        <span>{{ errorMessage }}</span>
      </div>
    </transition>

    <transition name="fade">
      <div
        v-if="successMessage"
        class="ftn-message__alert ftn-message__alert_success"
        role="alert"
        @click="copySuccessMessage"
      >
        <CheckMarkIcon class="ftn-message__icon" />
        <span>{{ successMessage }}</span>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import icons from '@/mixins/icons';

import CheckMarkIcon from '@/assets/icons/check-mark.svg?inline';
import ErrorMarkIcon from '@/assets/icons/error.svg?inline';

export default {
  mixins: [icons],
  name: 'OverlayError',
  components: {
    CheckMarkIcon,
    ErrorMarkIcon,
  },
  computed: {
    ...mapGetters({
      errorMessage: 'errorOverlay/message',
    }),
    ...mapGetters({
      successMessage: 'successOverlay/message',
    }),
  },
  methods: {
    ...mapMutations({
      setErrorMessage: 'errorOverlay/setErrorMessage',
      setSuccessMessage: 'successOverlay/setSuccessMessage',
    }),
    copyErrorMessage() {
      navigator.clipboard.writeText(this.errorMessage)
        .then(() => {
          this.setErrorMessage(null);
        });
    },
    copySuccessMessage() {
      navigator.clipboard.writeText(this.successMessage)
        .then(() => {
          this.setSuccessMessage(null);
        });
    },
  },
};
</script>
